var map = {
  "./cs.json": [
    "la",
    [
      "z2"
    ]
  ],
  "./en.json": [
    "T1",
    [
      "5tk"
    ]
  ],
  "./ru.json": [
    "Dj",
    [
      "h0"
    ]
  ],
  "./tr.json": [
    "xT",
    [
      "7t"
    ]
  ],
  "./zh.json": [
    "hY",
    [
      "jrb"
    ]
  ],
  "./ja.json": [
    "wF",
    [
      "uvb"
    ]
  ],
  "./pt-br.json": [
    "GiK",
    [
      "s1"
    ]
  ],
  "./de.json": [
    "dKh",
    [
      "75r"
    ]
  ],
  "./es.json": [
    "Cp",
    [
      "ww"
    ]
  ],
  "./fr.json": [
    "zh",
    [
      "dw"
    ]
  ],
  "./it.json": [
    "g9",
    [
      "ac"
    ]
  ],
  "./ko.json": [
    "GzM",
    [
      "su"
    ]
  ],
  "./pt.json": [
    "zm3",
    [
      "p2a"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "FNj";
module.exports = __rspack_async_context;
